import {
    FETCH_USER,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILED,
    USER_SIGN_IN,
    USER_SIGN_IN_FAILED,
    USER_SIGN_OUT,
    CLEAR_LOGIN_ERROR,
    REQUEST_OTP_SUCCESS,
    SEND_RESET_EMAIL,
    SEND_RESET_EMAIL_FAILED,
    SEND_RESET_EMAIL_SUCCESS,
    RESET_TRIP_DATA,
} from "../store/types";
import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { onValue, update, set, off } from "firebase/database";
import {
    onAuthStateChanged,
    signInWithCredential,
    signInWithPopup,
    signOut,
    sendPasswordResetEmail,
    signInWithEmailAndPassword,
} from "firebase/auth";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import base64 from "react-native-base64";
import AccessKey from "../other/AccessKey";

// Load config for API endpoints
const config = require("../../../config.json");

export const fetchUser = () => (dispatch) => {
    // console.log('👤 === FETCH USER DEBUG START ==='); // Removed repetitive log
    const { auth, singleUserRef } = firebase;

    // console.log('🔥 Firebase auth instance:', auth ? 'Available' : 'Missing'); // Removed repetitive log
    // console.log('📊 Single user ref:', singleUserRef ? 'Available' : 'Missing'); // Removed repetitive log

    dispatch({
        type: FETCH_USER,
        payload: null,
    });
    onAuthStateChanged(auth, (user) => {
        // console.log('🔄 Auth state changed'); // Removed repetitive log
        // console.log('👤 User object:', user ? 'Available' : 'Missing'); // Removed repetitive log

        if (user) {
            // console.log('✅ User authenticated'); // Removed repetitive log
            // console.log('🆔 User UID:', user.uid); // Removed repetitive log
            // console.log('📱 Phone Number:', user.phoneNumber); // Removed repetitive log
            // console.log('📧 Email:', user.email); // Removed repetitive log

            onValue(singleUserRef(user.uid), async (snapshot) => {
                // console.log('📊 Database snapshot received'); // Removed repetitive log
                // console.log('📋 Snapshot exists:', snapshot.exists()); // Removed repetitive log
                // console.log('📋 Snapshot value:', snapshot.val() ? 'Available' : 'Missing'); // Removed repetitive log

                if (snapshot.val()) {
                    // console.log('✅ User data exists in database'); // Removed repetitive log
                    let profile = snapshot.val();
                    profile.uid = user.uid;
                    // console.log('👤 User profile loaded:', { uid: profile.uid, firstName: profile.firstName, lastName: profile.lastName, mobile: profile.mobile, usertype: profile.usertype }); // Removed repetitive log

                    // Give registration bonus points for existing users who don't have points yet
                    try {
                        const pointsApiUrl =
                            config.api_endpoints?.ecommerce_base_url ||
                            "https://devecommerce.bettercoffee.my.id/api";
                        const userPointsResponse = await fetch(
                            `${pointsApiUrl}/v1/points/user/${user.uid}`
                        );

                        if (userPointsResponse.status === 404) {
                            // User doesn't have points yet, give registration bonus
                            const pointsResponse = await fetch(
                                `${pointsApiUrl}/v1/points`,
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        user_id: user.uid,
                                        key_setting: ["registration_bonus"],
                                    }),
                                }
                            );

                            if (pointsResponse.ok) {
                                const pointsResult =
                                    await pointsResponse.json();
                                console.log(
                                    "✅ Registration bonus points given to existing user without points"
                                );
                                console.log(
                                    "Points API response:",
                                    pointsResult
                                );
                            } else {
                                console.log(
                                    "⚠️ Failed to give registration bonus points:",
                                    pointsResponse.status
                                );
                            }
                        }
                    } catch (pointsError) {
                        console.error(
                            "❌ Error checking/giving registration bonus points:",
                            pointsError
                        );
                        // Don't fail login if points creation fails
                    }

                    dispatch({
                        type: FETCH_USER_SUCCESS,
                        payload: profile,
                    });
                    // console.log('✅ User profile dispatched successfully'); // Removed repetitive log
                } else {
                    console.log(
                        "🆕 User data does not exist - creating new user"
                    );
                    let mobile = "";
                    let email = "";
                    let firstName = "";
                    let lastName = "";
                    let verifyId = "";
                    let profile_image = null;
                    if (user.providerData.length == 0 && user.email) {
                        email = user.email;
                    }
                    if (user.providerData.length > 0 && user.phoneNumber) {
                        mobile = user.phoneNumber;
                    }
                    if (user.providerData.length > 0) {
                        const provideData = user.providerData[0];
                        if (provideData == "phone") {
                            mobile = provideData.phoneNumber;
                        }
                        if (
                            provideData.providerId == "facebook.com" ||
                            provideData.providerId == "apple.com"
                        ) {
                            if (provideData.email) {
                                email = provideData.email;
                            }
                            if (provideData.phoneNumber) {
                                mobile = provideData.phoneNumber;
                            }
                            if (provideData.displayName) {
                                if (
                                    provideData.displayName.split(" ").length >
                                    0
                                ) {
                                    firstName =
                                        provideData.displayName.split(" ")[0];
                                    lastName =
                                        provideData.displayName.split(" ")[1];
                                } else {
                                    firstName = provideData.displayName;
                                }
                            }
                            if (provideData.photoURL) {
                                profile_image = provideData.photoURL;
                            }
                        }
                    }

                    if (user.providerData.length > 0 && user.verifyId) {
                        verifyId = user.verifyId;
                    }

                    console.log("🌍 Detecting user country...");
                    const response = await fetch("https://api.country.is", {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    });
                    const json = await response.json();
                    console.log("🌍 Country detection result:", json);

                    const countries =
                        store.getState().countrylistdata.countries;

                    let countryDetail;
                    for (let i = 0; i < countries.length; i++) {
                        if (countries[i].country_code === json.country) {
                            countryDetail = countries[i];
                            break;
                        }
                    }

                    if (!countryDetail && countries.length > 0) {
                        countryDetail = countries[0];
                    }

                    if (countryDetail && countryDetail.country) {
                        console.log(
                            "✅ Country detected:",
                            countryDetail.country
                        );
                        const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                        const reference = [...Array(5)]
                            .map((_) => c[~~(Math.random() * c.length)])
                            .join("");
                        let userData = {
                            createdAt: new Date().getTime(),
                            firstName: firstName,
                            lastName: lastName,
                            mobile: mobile,
                            email: email,
                            usertype: "customer",
                            referralId: reference,
                            approved: true,
                            walletBalance: 0,
                            verifyId: verifyId,
                            country: countryDetail.country,
                            country_code: countryDetail.country_code,
                            currency_code: countryDetail.currency_code,
                            swipe_symbol: countryDetail.swipe_symbol,
                            symbol: countryDetail.symbol,
                        };
                        if (profile_image) {
                            userData["profile_image"] = profile_image;
                        }

                        console.log("📝 Creating new user data:", userData);
                        set(singleUserRef(user.uid), userData);
                        userData.uid = user.uid;
                        console.log("✅ New user data saved to database");

                        // Create free subscription for new user if they don't have one
                        try {
                            const subscriptionResponse = await fetch(
                                `https://${config.projectId}.web.app/subscription-getUserSubscription?userId=${user.uid}`
                            );
                            const subscriptionData =
                                await subscriptionResponse.json();

                            // if (!subscriptionData.success || !subscriptionData.subscription) {
                            //   // User doesn't have subscription, check what plans are available and assign appropriately
                            //   console.log(`🔍 Checking available subscription plans for user type: ${userData.usertype}`);

                            //   // Get available plans for this user type
                            //   const plansResponse = await fetch(`https://${config.projectId}.web.app/subscription-getSubscriptionPlans?userType=${userData.usertype}&showAll=true`);
                            //   const plansData = await plansResponse.json();

                            //   if (plansData.success && plansData.plans && Object.keys(plansData.plans).length > 0) {
                            //     // Plans exist, find the most appropriate one to assign
                            //     const availablePlans = Object.values(plansData.plans);

                            //     // Priority: Free plans first (active then inactive), then lowest price
                            //     const freePlans = availablePlans.filter(plan => plan.price === 0);
                            //     let planToAssign = null;

                            //     if (freePlans.length > 0) {
                            //       // Prefer active free plans first
                            //       planToAssign = freePlans.find(plan => plan.isActive === true) || freePlans[0];
                            //     } else {
                            //       // No free plans, use lowest price plan
                            //       planToAssign = availablePlans.sort((a, b) => a.price - b.price)[0];
                            //     }

                            //     console.log(`📋 Assigning existing plan: ${planToAssign.id} (price: ${planToAssign.price}, active: ${planToAssign.isActive})`);

                            //     // Create subscription with the existing plan, preserving its status
                            //     const createSubscriptionResponse = await fetch(`https://${config.projectId}.web.app/subscription-createSubscription`, {
                            //       method: 'POST',
                            //       headers: {
                            //         'Content-Type': 'application/json',
                            //       },
                            //       body: JSON.stringify({
                            //         userId: user.uid,
                            //         planId: planToAssign.id,
                            //         paymentMethod: planToAssign.price === 0 ? 'free' : 'pending',
                            //         receiptUrl: null,
                            //         payableAmount: planToAssign.price || 0,
                            //         usedWalletMoney: 0,
                            //         preservePlanStatus: true // Flag to preserve original plan status
                            //       })
                            //     });

                            //     const createResult = await createSubscriptionResponse.json();
                            //     if (createResult.success) {
                            //       console.log(`✅ Subscription assigned for user on first login: ${planToAssign.id} (status preserves plan's original state)`);
                            //     } else {
                            //       console.log('⚠️ Failed to assign subscription:', createResult.error);
                            //     }
                            //   } else {
                            //     // No plans exist, will be handled by backend function if needed
                            //     console.log('📝 No subscription plans exist yet, backend will handle plan creation if needed');
                            //   }
                            // }
                        } catch (subscriptionError) {
                            console.error(
                                "❌ Error handling subscription for new user:",
                                subscriptionError
                            );
                            // Don't fail login if subscription creation fails
                        }

                        // Give registration bonus points for new users
                        try {
                            const pointsApiUrl =
                                config.api_endpoints?.ecommerce_base_url ||
                                "https://devecommerce.bettercoffee.my.id/api";
                            const pointsResponse = await fetch(
                                `${pointsApiUrl}/v1/points`,
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        user_id: user.uid,
                                        key_setting: ["registration_bonus"],
                                    }),
                                }
                            );

                            if (pointsResponse.ok) {
                                const pointsResult =
                                    await pointsResponse.json();
                                console.log(
                                    "✅ Registration bonus points given to new user on first login"
                                );
                                console.log(
                                    "Points API response:",
                                    pointsResult
                                );
                            } else {
                                console.log(
                                    "⚠️ Failed to give registration bonus points:",
                                    pointsResponse.status
                                );
                            }
                        } catch (pointsError) {
                            console.error(
                                "❌ Error giving registration bonus points:",
                                pointsError
                            );
                            // Don't fail login if points creation fails
                        }

                        dispatch({
                            type: FETCH_USER_SUCCESS,
                            payload: userData,
                        });
                        console.log(
                            "✅ New user profile dispatched successfully"
                        );
                    } else {
                        console.error("❌ Country detection failed");
                        dispatch({
                            type: FETCH_USER_FAILED,
                            payload: {
                                code: store.getState().languagedata
                                    .defaultLanguage.login_error,
                                message:
                                    store.getState().languagedata
                                        .defaultLanguage.location_fetch_error,
                            },
                        });
                    }
                }
            });
        } else {
            console.log("❌ No user authenticated");
            dispatch({
                type: FETCH_USER_FAILED,
                payload: {
                    code:
                        store.getState().languagedata.defaultLanguage
                            ?.auth_error || "auth_error",
                    message:
                        store.getState().languagedata.defaultLanguage
                            ?.not_logged_in || "Not logged in",
                },
            });
        }
        // console.log('👤 === FETCH USER DEBUG END ==='); // Removed repetitive log
    });
};

export const validateReferer = async (referralId) => {
    const { config } = firebase;
    const response = await fetch(
        `https://${config.projectId}.web.app/validate_referrer`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                referralId: referralId,
            }),
        }
    );
    const json = await response.json();
    return json;
};

export const checkUserExists = async (data) => {
    const { config } = firebase;

    const settings = store.getState().settingsdata.settings;
    let host =
        window &&
        window.location &&
        settings.CompanyWebsite === window.location.origin
            ? window.location.origin
            : `https://${config.projectId}.web.app`;
    let url = `${host}/check_user_exists`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization:
                "Basic " + base64.encode(config.projectId + ":" + AccessKey),
        },
        body: JSON.stringify({
            email: data.email,
            mobile: data.mobile,
        }),
    });
    const json = await response.json();
    return json;
};

export const mainSignUp = async (regData) => {
    const { config } = firebase;
    let url = `https://${config.projectId}.web.app/user_signup`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ regData: regData }),
    });
    const res = await response.json();
    return res;
};

export const updateProfileWithEmail = (profileData) => async (dispatch) => {
    const { config } = firebase;
    try {
        const settings = store.getState().settingsdata.settings;
        let host =
            window &&
            window.location &&
            settings.CompanyWebsite === window.location.origin
                ? window.location.origin
                : `https://${config.projectId}.web.app`;
        let url = `${host}/update_user_email`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization:
                    "Basic " +
                    base64.encode(config.projectId + ":" + AccessKey),
            },
            body: JSON.stringify(profileData),
        });
        const result = await response.json();
        if (result.error) {
            return { success: false, error: result.error };
        }
    } catch (error) {
        return { success: false, error: error };
    }
};

export const requestPhoneOtpDevice = (verificationId) => async (dispatch) => {
    console.log("📱 === REQUEST PHONE OTP DEVICE DEBUG START ===");
    console.log("📱 requestPhoneOtpDevice function called");
    console.log("🆔 Verification ID:", verificationId);

    dispatch({
        type: REQUEST_OTP_SUCCESS,
        payload: verificationId,
    });

    console.log("✅ OTP request dispatched successfully");
    console.log("📱 === REQUEST PHONE OTP DEVICE DEBUG END ===");
};

export const mobileSignIn = (verificationId, code) => (dispatch) => {
    console.log("🔐 === MOBILE SIGN IN DEBUG START ===");
    console.log("🔐 mobileSignIn function called");
    console.log("🆔 Verification ID:", verificationId);
    console.log("🔢 Verification Code:", code);
    console.log("🔢 Code length:", code ? code.length : 0);

    const { auth, mobileAuthCredential } = firebase;

    console.log("🔥 Firebase auth instance:", auth ? "Available" : "Missing");
    console.log(
        "🔑 mobileAuthCredential function:",
        mobileAuthCredential ? "Available" : "Missing"
    );

    dispatch({
        type: USER_SIGN_IN,
        payload: null,
    });

    console.log("📤 Creating credential with mobileAuthCredential...");
    try {
        const credential = mobileAuthCredential(verificationId, code);
        console.log(
            "✅ Credential created:",
            credential ? "Success" : "Failed"
        );

        console.log("🔐 Signing in with credential...");
        signInWithCredential(auth, credential)
            .then((user) => {
                console.log("✅ Authentication successful");
                console.log("👤 User UID:", user.uid);
                console.log("📱 Phone Number:", user.phoneNumber);
                console.log("📧 Email:", user.email);
                console.log("🔐 === MOBILE SIGN IN DEBUG END ===");
                //OnAuthStateChange takes care of Navigation
            })
            .catch((error) => {
                console.error("💥 Authentication failed:");
                console.error("   Error Code:", error.code);
                console.error("   Error Message:", error.message);
                console.error("   Error Stack:", error.stack);
                console.error(
                    "   Full Error Object:",
                    JSON.stringify(error, null, 2)
                );

                dispatch({
                    type: USER_SIGN_IN_FAILED,
                    payload: error,
                });
                console.log("🔐 === MOBILE SIGN IN DEBUG END (ERROR) ===");
            });
    } catch (credentialError) {
        console.error("💥 Credential creation failed:");
        console.error("   Error:", credentialError);
        console.error("   Verification ID:", verificationId);
        console.error("   Code:", code);

        dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: credentialError,
        });
        console.log("🔐 === MOBILE SIGN IN DEBUG END (CREDENTIAL ERROR) ===");
    }
};

export const facebookSignIn = (token) => (dispatch) => {
    const { auth, facebookProvider, facebookCredential } = firebase;

    dispatch({
        type: USER_SIGN_IN,
        payload: null,
    });
    if (token) {
        const credential = facebookCredential(token);
        signInWithCredential(auth, credential)
            .then((user) => {
                //OnAuthStateChange takes care of Navigation
            })
            .catch((error) => {
                dispatch({
                    type: USER_SIGN_IN_FAILED,
                    payload: error,
                });
            });
    } else {
        signInWithPopup(auth, facebookProvider)
            .then(function (result) {
                var token = result.credential.accessToken;
                const credential = facebookCredentialFromResult(token);
                signInWithCredential(auth, credential)
                    .then((user) => {
                        //OnAuthStateChange takes care of Navigation
                    })
                    .catch((error) => {
                        dispatch({
                            type: USER_SIGN_IN_FAILED,
                            payload: error,
                        });
                    });
            })
            .catch(function (error) {
                dispatch({
                    type: USER_SIGN_IN_FAILED,
                    payload: error,
                });
            });
    }
};

// Apple Sign In removed due to iOS 18 SDK compatibility issues
// export const appleSignIn = (credentialData) => (dispatch) => {
//   // Function disabled - Apple Authentication removed
//   dispatch({
//     type: USER_SIGN_IN_FAILED,
//     payload: { message: 'Apple Sign In not available' }
//   });
// };

export const signOff = () => (dispatch) => {
    const {
        auth,
        singleUserRef,
        walletHistoryRef,
        userNotificationsRef,
        addressEditRef,
        userLocationRef,
    } = firebase;

    const uid = auth.currentUser.uid;

    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
    off(addressEditRef(uid));
    off(userLocationRef(uid));

    onValue(
        singleUserRef(uid),
        (snapshot) => {
            if (snapshot.val()) {
                const profile = snapshot.val();
                if (profile && profile.usertype === "driver") {
                    update(singleUserRef(uid), { driverActiveStatus: false });
                }
                // Remove setTimeout delay - logout should be instant
                signOut(auth)
                    .then(() => {
                        // Reset trip data on logout
                        dispatch({
                            type: RESET_TRIP_DATA,
                            payload: null,
                        });

                        dispatch({
                            type: USER_SIGN_OUT,
                            payload: null,
                        });
                    })
                    .catch((error) => {
                        console.error("Logout error:", error);
                    });
            }
        },
        { onlyOnce: true }
    );
};

export const updateProfile = (updateData) => async (dispatch) => {
    const {
        auth,
        singleUserRef,
        driverDocsRef,
        driverDocsRefBack,
        verifyIdImageRef,
    } = firebase;

    const uid = auth.currentUser.uid;

    try {
        console.log("🔄 [authactions] Starting profile update:", {
            uid,
            updateData,
            hasLicenseImage: !!updateData.licenseImage,
            hasLicenseImageBack: !!updateData.licenseImageBack,
            hasVerifyIdImage: !!updateData.verifyIdImage,
        });

        // Handle image uploads first
        if (updateData.licenseImage) {
            console.log("📤 [authactions] Uploading license image...");
            await uploadBytesResumable(
                driverDocsRef(uid),
                updateData.licenseImage
            );
            updateData.licenseImage = await getDownloadURL(driverDocsRef(uid));
            console.log("✅ [authactions] License image uploaded successfully");
        }
        if (updateData.licenseImageBack) {
            console.log("📤 [authactions] Uploading license image back...");
            await uploadBytesResumable(
                driverDocsRefBack(uid),
                updateData.licenseImageBack
            );
            updateData.licenseImageBack = await getDownloadURL(
                driverDocsRefBack(uid)
            );
            console.log(
                "✅ [authactions] License image back uploaded successfully"
            );
        }
        if (updateData.verifyIdImage) {
            console.log("📤 [authactions] Uploading verify ID image...");
            await uploadBytesResumable(
                verifyIdImageRef(uid),
                updateData.verifyIdImage
            );
            updateData.verifyIdImage = await getDownloadURL(
                verifyIdImageRef(uid)
            );
            console.log(
                "✅ [authactions] Verify ID image uploaded successfully"
            );
        }

        console.log(
            "📤 [authactions] Updating profile data in Firebase:",
            updateData
        );
        console.log("📍 [authactions] Firebase path:", `users/${uid}`);

        // Update profile data in Firebase
        await update(singleUserRef(uid), updateData);

        console.log(
            "✅ [authactions] Profile updated successfully in Firebase"
        );

        // Dispatch success action
        dispatch({
            type: "PROFILE_UPDATE_SUCCESS",
            payload: updateData,
        });

        console.log("✅ [authactions] Redux action dispatched successfully");

        return { success: true, data: updateData };
    } catch (error) {
        console.error("❌ [authactions] Error updating profile:", error);
        console.error("❌ [authactions] Error details:", {
            message: error.message,
            code: error.code,
            stack: error.stack,
        });

        // Dispatch error action
        dispatch({
            type: "PROFILE_UPDATE_ERROR",
            payload: error.message,
        });

        throw error;
    }
};

export const updateProfileImage = (imageBlob) => {
    const { auth, singleUserRef, profileImageRef } = firebase;

    const uid = auth.currentUser.uid;

    uploadBytesResumable(profileImageRef(uid), imageBlob)
        .then(() => {
            imageBlob.close();
            return getDownloadURL(profileImageRef(uid));
        })
        .then((url) => {
            update(singleUserRef(uid), {
                profile_image: url,
            });
        });
};

export const updateWebProfileImage = async (imageBlob) => {
    const { auth, singleUserRef, profileImageRef } = firebase;

    const uid = auth.currentUser.uid;

    await uploadBytesResumable(profileImageRef(uid), imageBlob);
    let image = await getDownloadURL(profileImageRef(uid));
    update(singleUserRef(uid), { profile_image: image });
};

export const updatePushToken = (token, platform) => {
    const { auth, singleUserRef } = firebase;

    const uid = auth.currentUser.uid;

    update(singleUserRef(uid), {
        pushToken: token,
        userPlatform: platform,
    });
};

export const clearLoginError = () => (dispatch) => {
    dispatch({
        type: CLEAR_LOGIN_ERROR,
        payload: null,
    });
};

export const sendResetMail = (email) => async (dispatch) => {
    const { authRef } = firebase;

    dispatch({
        type: SEND_RESET_EMAIL,
        payload: email,
    });
    sendPasswordResetEmail(authRef(), email)
        .then(function () {
            dispatch({
                type: SEND_RESET_EMAIL_SUCCESS,
                payload: null,
            });
        })
        .catch(function (error) {
            dispatch({
                type: SEND_RESET_EMAIL_FAILED,
                payload: {
                    code: store.getState().languagedata.defaultLanguage
                        .auth_error,
                    message:
                        store.getState().languagedata.defaultLanguage
                            .not_registred,
                },
            });
        });
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
    const { authRef } = firebase;

    // COMMENTED: Step 1: Hit auto-login API first
    // try {
    //   const requestBody = {
    //     email: email,
    //     password: pass,
    //     redirect_url: "https://devecommerce.bettercoffee.my.id/user/dashboard"
    //   };

    //   // Log request details
    //   console.log('🚀 Auto-login API Request:');
    //   console.log('URL:', 'https://devecommerce.bettercoffee.my.id/api/mobile/auto-login');
    //   console.log('Method:', 'POST');
    //   console.log('Headers:', {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    //   });
    //   console.log('Request Body:', requestBody);

    //   const autoLoginResponse = await fetch('https://devecommerce.bettercoffee.my.id/api/mobile/auto-login', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Accept': 'application/json'
    //     },
    //     body: JSON.stringify(requestBody)
    //   });

    //   const autoLoginResult = await autoLoginResponse.json();

    //   // Log response details
    //   console.log('✅ Auto-login API Response:');
    //   console.log('Status:', autoLoginResponse.status);
    //   console.log('Response:', autoLoginResult);

    //   // Store auto-login result in user data if needed
    //   if (autoLoginResult.success && autoLoginResult.data) {
    //     console.log('🎉 Auto-login successful details:');
    //     console.log('Auto-login URL:', autoLoginResult.data.auto_login_url);
    //     console.log('Expires at:', autoLoginResult.data.expires_at);
    //     console.log('User data:', autoLoginResult.data.user);
    //     console.log('Registration mode:', autoLoginResult.data.registration_mode);
    //   } else {
    //     console.log('⚠️ Auto-login failed or no data:', autoLoginResult);
    //   }
    // } catch (error) {
    //   // If auto-login fails, just log it and continue with Firebase login
    //   console.log('❌ Auto-login API error:', error);
    // }

    // Step 2: Continue with Firebase login as usual
    signInWithEmailAndPassword(authRef(), email, pass)
        .then((user) => {
            //OnAuthStateChange takes care of Navigation
        })
        .catch((error) => {
            console.log("Error: ", error);
            dispatch({
                type: USER_SIGN_IN_FAILED,
                payload: error,
            });
        });
};

// COMMENTED: New function to handle auto-login API separately if needed
// export const callAutoLoginAPI = async (email, password) => {
//   try {
//     const requestBody = {
//       email: email,
//       password: password,
//       redirect_url: "https://devecommerce.bettercoffee.my.id/user/dashboard"
//     };

//     // Log request details
//     console.log('🚀 Auto-login API Request (Helper Function):');
//     console.log('URL:', 'https://devecommerce.bettercoffee.my.id/api/mobile/auto-login');
//     console.log('Method:', 'POST');
//     console.log('Headers:', {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     });
//     console.log('Request Body:', requestBody);

//     const response = await fetch('https://devecommerce.bettercoffee.my.id/api/mobile/auto-login', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify(requestBody)
//     });

//     const result = await response.json();

//     // Log response details
//     console.log('✅ Auto-login API Response (Helper Function):');
//     console.log('Status:', response.status);
//     console.log('Response:', result);

//     return result;
//   } catch (error) {
//     console.log('❌ Auto-login API error (Helper Function):', error);
//     return { success: false, error: error };
//   }
// };
